"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./style.less");

var _antd = require("antd");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SATURATION = 30;
var LIGHTNESS = 80;
var MAX_WORDS = 2;
var DEFAULT_REGION = 'ES';

var Avatar = function Avatar(_ref) {
  var src = _ref.src,
      name = _ref.name,
      icon = _ref.icon,
      size = _ref.size,
      _ref$region = _ref.region,
      region = _ref$region === void 0 ? DEFAULT_REGION : _ref$region,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["src", "name", "icon", "size", "region", "className"]);

  var backgroundColor = (0, _react.useMemo)(function () {
    if (src || !name) {
      return null;
    }

    var hash = 0;

    for (var i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }

    var hue = hash % 360; // See https://medium.com/@pppped/compute-an-arbitrary-color-for-user-avatar-starting-from-his-username-with-javascript-cd0675943b66

    return "hsl(".concat(hue, ", ").concat(SATURATION, "%, ").concat(LIGHTNESS, "%)");
  }, [src, name]);
  var initials = (0, _react.useMemo)(function () {
    if (src || !name) {
      return null;
    }

    var words = name.split(' ').filter(function (str) {
      return str.length > 0;
    });

    switch (region) {
      case 'PT':
      case 'BR':
        // For reasons passing human understanding we support different initials when the
        // names correspond to Portugal or Brazil. See, in those countries we need to use
        // the FIRST and LAST words instead of the first two...
        if (words.length === 1) {
          return words[0][0].toUpperCase();
        } // This assumes MAX_WORDS = 2, because what should we do otherwise?


        return [words[0], words.slice(-1)[0]].map(function (word) {
          return word[0].toUpperCase();
        }).join('');

      default:
        return words.slice(0, MAX_WORDS).map(function (word) {
          return word[0].toUpperCase();
        }).join('');
    }
  }, [src, name, region]);
  var classNames = (0, _react.useMemo)(function () {
    return "".concat(className, " AplanetAvatar ").concat(src ? 'AplanetAvatar-img' : name ? 'AplanetAvatar-initials' : 'AplanetAvatar-icon');
  }, [src, name, className]);
  var fontSize = (0, _react.useMemo)(function () {
    return size && typeof size === 'number' ? Math.ceil(size / 2) : 'inherit';
  }, [size]);
  return src ? /*#__PURE__*/_react.default.createElement(_antd.Avatar, _extends({
    src: src,
    size: size,
    className: classNames
  }, props)) : name ? /*#__PURE__*/_react.default.createElement(_antd.Avatar, _extends({
    style: {
      backgroundColor: backgroundColor,
      fontSize: fontSize
    },
    size: size,
    className: classNames
  }, props), initials) : /*#__PURE__*/_react.default.createElement(_antd.Avatar, _extends({
    icon: icon,
    size: size,
    className: classNames
  }, props));
};

var _default = Avatar;
exports.default = _default;